import { render, staticRenderFns } from "./shareVideo.vue?vue&type=template&id=718f3f7c&"
import script from "./shareVideo.vue?vue&type=script&lang=ts&"
export * from "./shareVideo.vue?vue&type=script&lang=ts&"
import style0 from "./shareVideo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports